import type { IComponentController } from "angular";
import { map } from "rxjs/operators";

import type { IOperatorStationSlim } from "App/Modules/Models";
import type { IEquipmentRepository } from "App/Modules/Repositories";

export default class FindAddArcOperatorStationComponentController implements IComponentController {
    public static $inject: string[] = ["mmEquipmentRepository"];

    public partnerId: string;

    public newOperatorStation: (params: { searchString: string }) => void;

    public selectOperatorStation: (params: { operatorStation: IOperatorStationSlim }) => void;

    public selectedOperatorStation: IOperatorStationSlim;

    public canAddOperatorStation: boolean;

    public clearAfterAdd: boolean;

    public hideTitle: boolean;

    public removeFromResult: string[];

    private searchString: string;

    constructor(private readonly equipmentRepository: IEquipmentRepository) {}

    public operatorStationSearch(value: string) {
        return this.equipmentRepository
            .searchDecoupledOperatorStations(value)
            .pipe(
                map((result) => {
                    this.searchString = value;

                    const suggested = result.data.slice(0, 8);

                    if (this.canAddOperatorStation || this.canAddOperatorStation === undefined) {
                        suggested.push({
                            computerName: "testing",
                        } as IOperatorStationSlim);
                    }

                    return suggested;
                }),
            )
            .toPromise();
    }

    public operatorStationSelected(operatorStation: IOperatorStationSlim) {
        if (!operatorStation.id) {
            if (this.newOperatorStation) {
                this.newOperatorStation({ searchString: this.searchString });
            }
        } else if (this.selectOperatorStation) {
            this.selectOperatorStation({ operatorStation });
        }
        if (this.clearAfterAdd) {
            this.selectedOperatorStation = null;
        }
    }
}
